import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TidService } from '../auth/services/tid.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent {
  currentYear: number;
  constructor(private tidService: TidService, private router: Router) {
    this.currentYear = new Date().getFullYear();
  }

  redirectSignup() {
    this.tidService.accounts$.next([]);
    this.tidService.email = '';
    this.tidService.errorMessage.next(null);
  }
  navigateToFeatureSignup(featurelevel) {
    window.location.href = `/signup?featureLevel=${featurelevel}&landing=true`;
  }
}
